<app-toast></app-toast>
<div class="h-screen flex flex-col items-center p-5 mobile:p-2">
    <!-- Top bar-->
    <div class="w-full">
        <app-admin-topbar></app-admin-topbar>
    </div>

    <!-- Tab Navigation -->
    <div class="w-full">
        <app-admin-navigation [isActiveNumber]="2"></app-admin-navigation>
    </div>

    <!--Sales agents by period-->
    <div class="w-full h-full border-[1px] border-border rounded-[20px] flex flex-col mt-2">
        <!-- Header text -->
        <div class="flex">
            <div class="flex flex-col gap-4 h-[60px] justify-between">
                <p class="text-primary font-semibold ml-4 mr-4 mt-4 mobile:text-sm">{{ 'admin.sales_agents_by_period'
                    | transloco }}
                </p>
                <div class="h-[2px] w-full bg-primary"></div>
            </div>
            <div class="h-[60px] flex flex-grow items-end justify-start mobile:hidden">
                <div class="h-[2px] w-full bg-border"></div>
            </div>
        </div>

        <!--Content-->
        <div class="w-full flex flex-col gap-2 p-5">
            <div class="w-full flex desktop:flex-wrap gap-2 justify-end items-end mobile:flex-col">
                <!--Choose period-->
                <div class="min-w-[300px] max-w-[600px]">
                    <app-custom-date-input labelText="{{ 'admin.from' | transloco }}" inputId="fromPeriod"
                        placeholder="{{ 'admin.from' | transloco }}" [(dateValue)]="fromPeriodDate"
                        [errorMessage]="fromPeriodInputError" dateFormat="dd/mm/yy"
                        boxHeight="min-h-[50px] max-h-[70px]"></app-custom-date-input>
                </div>
                <div class="min-w-[300px] max-w-[600px]">
                    <app-custom-date-input labelText="{{ 'admin.to' | transloco }}" inputId="toPeriod"
                        placeholder="{{ 'admin.to' | transloco }}" [(dateValue)]="toPeriodDate"
                        [errorMessage]="toPeriodInputError" dateFormat="dd/mm/yy"
                        boxHeight="min-h-[50px] max-h-[70px]"></app-custom-date-input>
                </div>
                <div class="w-[150px] h-[50px] self-end">
                    <app-custom-button buttonText="{{ 'admin.refresh' | transloco }}" [isDisabled]="false"
                        backgroundColor="bg-secondary" textColor="text-black" borderColor="border:bg-secondary"
                        hoverBackgroundColor="hover:bg-secondary-1200" hoverBorderColor="hover:border-secondary-1200"
                        (click)="refreshPeriod()">
                    </app-custom-button>
                </div>
                <div class="w-[150px] h-[50px] self-end">
                    <app-custom-button buttonText="{{ 'invoice.csv_export' | transloco }}" [isDisabled]="false"
                        backgroundColor="bg-primary" textColor="text-black" borderColor="border:bg-primary"
                        hoverBackgroundColor="hover:bg-primary-1200" hoverBorderColor="hover:border-primary-1200"
                        (click)="downloadAgentsCSV(salesAgentsByPeriod)">
                    </app-custom-button>
                </div>
            </div>
            <div
                class="overflow-x-auto max-w-ultrawide justify-center mb-4 mobile:max-w-screen h-full block min-h-[500px] rounded-[16px]">
                <table class="table w-full">
                    <!-- Header -->
                    <thead class="bg-secondary-100 text-neutral-700 uppercase">
                        <tr class="max-h-[50px]">
                            <th class="border-b border-border px-4 py-4 font-normal">{{ 'admin.name' | transloco }}
                            </th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{ 'admin.email' | transloco }}
                            </th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{ 'admin.contact_number' |
                                transloco }}</th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{
                                'archive.overview.action' | transloco }}</th>
                        </tr>
                    </thead>

                    <!-- Content -->
                    <tbody>
                        <ng-container *ngFor="let agent of salesAgentsByPeriod; let i = index">
                            <tr class="max-h-[50px]">
                                <td class="border-b border-border px-4 py-4">{{ agent.name }}</td>
                                <td class="border-b border-border px-4 py-4">{{ agent.email }}</td>
                                <td class="border-b border-border px-4 py-4">{{ agent.contact_number }}</td>
                                <td class="border-b border-border px-4 py-4">
                                    <div class="flex gap-2 items-center">
                                        <button (click)="downloadAgentsCSV([agent])"
                                            title="{{ 'invoice.csv_export' | transloco }}">
                                            <img src="assets/icons/archive/download-circle.svg"
                                                class="w-[24px] h-[24px]" alt="{{ 'invoice.csv_export' | transloco }}">
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            <ng-container *ngIf="agent.referred_users?.length">
                                <tr>
                                    <td colspan="4" class="border-b border-border px-4 py-4">
                                        <div class="overflow-x-auto">
                                            <table class="table w-full bg-border">
                                                <thead class="bg-secondary-50 text-neutral-700 text-sm uppercase">
                                                    <tr>
                                                        <th class="border-b border-border px-2 py-2">{{ 'admin.name' |
                                                            transloco }}</th>
                                                        <th class="border-b border-border px-2 py-2">{{ 'admin.role' |
                                                            transloco }}</th>
                                                        <th class="border-b border-border px-2 py-2">{{ 'admin.joined' |
                                                            transloco }}</th>
                                                        <th class="border-b border-border px-2 py-2">{{
                                                            'admin.company_name' | transloco }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let user of agent.referred_users">
                                                        <td class="border-b border-border px-2 py-2">{{ user.first_name
                                                            }} {{ user.last_name }}</td>
                                                        <td class="border-b border-border px-2 py-2">{{ user.role }}
                                                        </td>
                                                        <td class="border-b border-border px-2 py-2">{{ user.joined |
                                                            isoDate }}</td>
                                                        <td class="border-b border-border px-2 py-2">{{
                                                            user.company?.name || '-' }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </ng-container>
                        </ng-container>

                        <tr *ngIf="salesAgentsByPeriod.length > 0 && !loadMoreHiddenSalesAgentsByPeriod">
                            <td colspan="4">
                                <div class="w-full h-full flex justify-center items-start">
                                    <div class="w-[150px] h-[50px]">
                                        <app-custom-button buttonText="{{ 'shared.load_more' | transloco }}"
                                            [isDisabled]="false" backgroundColor="bg-neutral-500" textColor="text-white"
                                            borderColor="border:bg-neutral-500"
                                            hoverBackgroundColor="hover:bg-neutral-1200"
                                            (buttonClick)="loadSalesAgentsByPeriodNewPage()">
                                        </app-custom-button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>